import { getSystemInfoApi } from 'src/api/common'

export default {
  namespaced: true,
  state: {
    systemInfo: null,
  },

  mutations: {
    SET_SYSTEM_INFO: (state, info) => {
      state.systemInfo = info || null
    },
  },

  actions: {
    async getSystemInfo ({ state, commit }) {
      try {
        let systemInfo = null
        if (!state.systemInfo) {
          systemInfo = await getSystemInfoApi()
          commit('SET_SYSTEM_INFO', systemInfo)
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
